'use client';

import Link from '@lichtblick/link';
import { type TrackingData, useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';
import type { Colors } from '../../types/colors';
import styles from './teaser-item.module.scss';

export type LinkProps = {
  href?: string;
  isDownloadLink?: boolean;
  onClick?: () => void;
  shouldOpenInNewTab?: boolean;
  title: string;
};

type TeaserItemProps = PropsWithChildren & {
  backgroundColor?: Colors;
  className?: string;
  headline?: string;
  link?: LinkProps;
  tracking?: TrackingData;
};

export const TeaserItemLink: FC<TeaserItemProps> = ({
  backgroundColor = 'White',
  children,
  className,
  headline,
  link,
  tracking,
}) => {
  const { trackCustomEvent } = useTracker();

  const trackEvent = (trackingData?: TrackingData) => {
    trackCustomEvent(trackingData);

    if (link?.href?.includes('onelink')) {
      trackCustomEvent(
        {
          eventName: 'app_link',
          customProps: {
            link_type: 'Onelink',
          },
        },
        undefined,
        false,
      );
    }
  };

  return (
    <Link
      aria-label={headline ?? link?.title}
      className={classNames(
        'teaser-item',
        styles.teaser,
        styles[`teaser-bg-${backgroundColor}`],
        styles['teaser-bg'],
        className,
      )}
      data-testid="teaser-item"
      download={link?.isDownloadLink}
      href={link?.href ?? '#'}
      onClick={() => {
        link?.onClick?.();
        trackEvent(tracking);
      }}
      target={link?.shouldOpenInNewTab ? '_blank' : undefined}
    >
      {children}
    </Link>
  );
};
